import type {
  CriterionCoachingGoal,
  CriterionCoachingGoalProgress,
} from "@repo/app-types/entities/teammatePlaybookCoaching";
import { IconFlag } from "@tabler/icons-react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

function formatGoalSummary(goal: CriterionCoachingGoal): string {
  if (goal.type === "score_target") {
    return goal.summary;
  }
  return goal.summary.replace("{count}", goal.goal_call_count.toLocaleString());
}

interface CoachingGoalSummaryProps {
  goal: CriterionCoachingGoal;
  goalProgress: CriterionCoachingGoalProgress | null | undefined;
}

export const CoachingGoalSummary: FC<CoachingGoalSummaryProps> = ({
  goal,
  goalProgress,
}) => {
  const formattedSummary = formatGoalSummary(goal);
  const observedCount = goalProgress?.observed_count ?? 0;

  return (
    <div className="flex gap-1.5 text-sm">
      <IconFlag className="mt-0.5 size-4 shrink-0 text-blue-500" />
      <div className="min-w-0 flex-1 space-y-2">
        <div className="flex items-baseline justify-between gap-2">
          <div className="font-medium text-foreground">{formattedSummary}</div>
          {goal.type !== "score_target" ? (
            <span className="shrink-0 text-xs text-muted-foreground tabular-nums">
              {observedCount}/{goal.goal_call_count}
            </span>
          ) : null}
        </div>
        {goal.type !== "score_target" ? (
          <div className="flex flex-1 gap-1">
            {Array.from({ length: goal.goal_call_count }, (_, i) => (
              <div
                key={i}
                className={twMerge(
                  "h-1.5 flex-1 rounded-xs",
                  i < observedCount ? "bg-green-500" : "bg-gray-200",
                )}
              />
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
};
